module.exports = __webpack_public_path__ + "img/xlsx.3d85067c.png";